<template>
  <div id="cart-bottom" :style="{height:tabHeight}">
    <div class="cart-bottom" :style="{bottom: mBottom}">
      <img class="select" :src="isSel===1?msgImg_s:msgImg_n" @click="allClick">
      <div class="all">全选</div>
      <div class="price"><span>实付款：</span>￥{{price}}</div>
      <div class="buybtn" :class="{ active: state, inactive: !state}" @click="cartBottomClick(2)">结算</div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  props: {
    price: '',
    state: 0, // 0 没有选中的商品 1 有选中的商品
    isAll: 0 // 是否全选
  },
  data () {
    return {
      tabHeight: '65px',
      mBottom: parseInt(this.$route.query.isTab) === 1 ? '50px' : '0px',
      msgImg_n: require('../../../assets/radio_n.png'),
      msgImg_s: require('../../../assets/radio_s.png'),
      isSel: 0
    }
  },
  
  methods: {
    allClick: function () {
      if (this.isSel === 0) {
        this.isSel = 1
      } else {
        this.isSel = 0
      }
      // click 0 取消全选 1 全选 2 点击结算
      this.$emit('click', this.isSel)
    },
    cartBottomClick: function (index) {
      // 0 购物车 1加入购物车 2 立即购买
      this.$emit('click', 2)
    },
    androidTabHeight: function (value) {
      // Toast('成功请求，底部高度===' + value)
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          if (parseInt(this.$route.query.isTab) === 1) {
            this.mBottom = '70px'
            this.tabHeight = '65px'
          } else {
            this.mBottom = '15px'
            this.tabHeight = '80px'
          }
        } else {
          if (parseInt(this.$route.query.isTab) === 1) {
            this.mBottom = '50px'
          } else {
            this.mBottom = '0px'
          }
          this.tabHeight = '65px'
        }
      } else {
        if (parseInt(this.$route.query.isTab) === 1) {
          this.mBottom = (50 + parseInt(value) + 'px')
        } else {
          this.mBottom = (parseInt(value) + 'px')
        }
        this.tabHeight = '65px'
        // Toast('mBottom===' + this.mBottom)
      }
      console.log("cart bottomNavigation高度updated:",this.$refs.bottomNavigation.offsetHeight)
    }
  },
  watch: {
    isAll (val) {
      if (val === 1) {
        this.isSel = 1
      } else {
        this.isSel = 0
      }
    }
  },
  beforeDestroy () {
  },
  mounted () {
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      var _this = this
      window['androidTabHeight'] = (result) => {
        _this.androidTabHeight(result)
      }
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
  }
}
</script>

<style scoped>
.cart-bottom {
  position: fixed;
  width: 100%;
  bottom: 0px;
  height: 65px;
  background-color: #ffffff;
  border-top: solid #eeeeee 1px;
  box-sizing: border-box;
  z-index: 500;
}
.cart-bottom .select {
  position: absolute;
  top: 22px;
  left: 15px;
  width: 20px;
  height: 20px;
}
.cart-bottom .all {
  position: absolute;
  top: 22px;
  left: 42px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #808080;
}
.cart-bottom .buybtn {
  position: absolute;
  top: 10px;
  right: 15px;
  width: 84px;
  height: 45px;
  line-height: 45px;
  border-radius: 4px;
  color: #ffffff;
  font-size: 15px;
  text-align: center;
}
.cart-bottom .price {
  position: absolute;
  top: 10px;
  right: 110px;
  height: 45px;
  line-height: 45px;
  font-size: 14px;
  color: #c41335;
  text-align: right;
}
.cart-bottom .price span {
  font-size: 12px;
  color: #000000;
}
.inactive {
  background-color: #fecdcd;
}
.active {
  background-color: #c41335;
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/shoppingCart/cart-bottom.vue